var _circle, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopSales(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#paint0_linear_1767_5515)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6665 17.042C9.52389 17.2627 11.253 18.1019 12.5756 19.4245C13.8982 20.7472 14.7374 22.4763 14.9582 24.3337C15.8789 23.8028 16.6491 23.046 17.1959 22.1346C17.7427 21.2233 18.0481 20.1876 18.0832 19.1253C19.8322 18.51 21.3596 17.3899 22.4721 15.9066C23.5846 14.4233 24.2322 12.6434 24.3332 10.792C24.3332 9.96319 24.0039 9.16833 23.4179 8.58228C22.8318 7.99623 22.037 7.66699 21.2082 7.66699C19.3568 7.76794 17.5769 8.4156 16.0936 9.52809C14.6103 10.6406 13.4901 12.1679 12.8748 13.917C11.8126 13.9521 10.7769 14.2574 9.86553 14.8043C8.95418 15.3511 8.19733 16.1212 7.6665 17.042Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 18.083C9.85304 18.7304 8.95343 19.2889 8.36448 20.4668C7.77553 21.6447 7.55178 22.9717 7.72191 24.2776C9.02781 24.4477 10.3548 24.224 11.5327 23.635C12.7106 23.0461 13.2691 22.5631 13.9165 21.4163",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3332 14.3333C20.2536 14.3333 20.9998 13.5871 20.9998 12.6667C20.9998 11.7462 20.2536 11 19.3332 11C18.4127 11 17.6665 11.7462 17.6665 12.6667C17.6665 13.5871 18.4127 14.3333 19.3332 14.3333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1767_5515",
    x1: -1,
    y1: 32.5,
    x2: 36.5,
    y2: 2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B6CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4776D0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopSales);
export default __webpack_public_path__ + "static/media/top-sales.3fec103dff17ab5a725fbbcbfe703216.svg";
export { ForwardRef as ReactComponent };